import { Node, Button } from 'cc';

declare module 'cc' {
    // eslint-disable-next-line @typescript-eslint/naming-convention, @typescript-eslint/no-shadow
    interface Button {
        _keep: boolean;
        _keepState: Button.State;
        keep: boolean;
        keepState: Button.State;
        ignoreStates: Button.State[];
        simulateDown(): void;
        simulateUp(): void;
        /**
         * update appearance according to the current button state
         */
        updateState(): void;
        getButtonState(): Button.State;
    }

    namespace Button {
        enum State {
            NORMAL = 'normal',
            HOVER = 'hover',
            PRESSED = 'pressed',
            DISABLED = 'disabled',
        }
    }

    namespace __private {
        export namespace _cocos_ui_button__EventType {
            export const STATE_RESET: string;
            export const INTERACTABLE_CHANGED: string;
            export const APPLY_TRANSITION: string;
            export const KEEP_STATE_CHANGED: string;
        }
    }
}

enum State {
    NORMAL = 'normal',
    HOVER = 'hover',
    PRESSED = 'pressed',
    DISABLED = 'disabled',
}

export { State as ButtonState };

Button.State = State;

Button.prototype.simulateDown = function simulateDown(this: Button) {
    this.node.emit(Node.EventType.TOUCH_START);
};

Button.prototype.simulateUp = function simulateUp(this: Button) {
    this.node.emit(Node.EventType.TOUCH_END);
};

Button.prototype.updateState = function updateState(this: Button) {
    this._updateState();
};

// @ts-ignore
const originalGetButtonState = Button.prototype._getButtonState;
// @ts-ignore
Button.prototype._getButtonState = function _getButtonState(this: Button) {
    if (this.keep && this.keepState) {
        return this.keepState;
    }
    return originalGetButtonState.call(this) as Button.State;
};

Button.prototype.getButtonState = function getButtonState(this: Button) {
    return this._getButtonState() as Button.State;
};

// @ts-ignore
const originalApplyTransition = Button.prototype._applyTransition;
// @ts-ignore
Button.prototype._applyTransition = function _applyTransition(this: Button, state: Button.State) {
    if (this.ignoreStates?.includes(state)) {
        return;
    }
    if (this.keep && this.keepState) {
        state = this.keepState;
    }
    originalApplyTransition.call(this, state);
    this.node.emit(Button.EventType.APPLY_TRANSITION, state);
};

// @ts-ignore
const originResetState = Button.prototype._resetState;
// @ts-ignore
Button.prototype._resetState = function _resetState(this: Button) {
    originResetState.call(this);
    this.node.emit(Button.EventType.STATE_RESET);
};

const originalDescriptor = Object.getOwnPropertyDescriptor(Button.prototype, 'interactable');
const originSetter = originalDescriptor.set;
originalDescriptor.set = function set(this: Button, value: boolean) {
    const changed = this._interactable !== value;
    originSetter.call(this, value);
    if (changed) {
        this.node.emit(Button.EventType.INTERACTABLE_CHANGED);
    }
};
Object.defineProperty(Button.prototype, 'interactable', originalDescriptor);

Object.defineProperty(Button.EventType, 'STATE_RESET', {
    value: 'STATE_RESET',
    writable: false,
    enumerable: true,
    configurable: true,
});

Object.defineProperty(Button.EventType, 'INTERACTABLE_CHANGED', {
    value: 'INTERACTABLE_CHANGED',
    writable: false,
    enumerable: true,
    configurable: true,
});

Object.defineProperty(Button.EventType, 'APPLY_TRANSITION', {
    value: 'APPLY_TRANSITION',
    writable: false,
    enumerable: true,
    configurable: true,
});

Object.defineProperty(Button.EventType, 'KEEP_STATE_CHANGED', {
    value: 'KEEP_STATE_CHANGED',
    writable: false,
    enumerable: true,
    configurable: true,
});

Object.defineProperty(Button.prototype, 'keep', {
    configurable: true,
    get(this: Button) {
        return this._keep ?? false;
    },
    set(this: Button, value: boolean) {
        if (this._keep === value) {
            return;
        }
        this._keep = value;
        this._updateState();
        this.node.emit(Button.EventType.KEEP_STATE_CHANGED, value);
    },
});

Object.defineProperty(Button.prototype, 'keepState', {
    configurable: true,
    get(this: Button) {
        return this._keepState ?? Button.State.PRESSED;
    },
    set(this: Button, value: Button.State) {
        if (this._keepState === value) {
            return;
        }
        this._keepState = value;
        this._updateState();
    },
});
